<div class="gift-details-skeleton">
  <app-skeleton className="w-100% ar-1/1 md:ar-auto md:w-140 md:h-140 r-12 c-post"></app-skeleton>
  <div class="gift-details-skeleton__content">
    <app-skeleton className="h-18 w-55% r-4 c-post"></app-skeleton>
    <div class="gift-details-skeleton__lines">
      <app-skeleton className="h-14 w-100% r-4 c-post"></app-skeleton>
      <app-skeleton className="h-14 w-90% r-4 c-post"></app-skeleton>
      <app-skeleton className="h-14 w-65% r-4 c-post"></app-skeleton>
    </div>
  </div>
</div>
